import React, { useEffect, useState } from "react";

import HelpPopup from "./HelpPopup";

const query = `
{
  prijzenkastUitlegCollection {
    items {
     titel,
      tekst
    }
  }
}
`;

type Item = {
  readonly titel: string;
  readonly tekst: string;
};

type Data = {
  readonly prijzenkastUitlegCollection: {
    readonly items: ReadonlyArray<Item>;
  };
};

type Response = {
  readonly data: Data;
  readonly errors: unknown;
};

export const HelpPopupContainer = (): React.ReactElement | null => {
  const [data, setData] = useState<null | Data>(null);

  useEffect(() => {
    void window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/t22qbzbg0h3n/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer hB7xO81jOlPGssTxq3rMAaLnll4iFGKM-5h1ROwg9UM",
        },
        body: JSON.stringify({ query }),
      })
      // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
      .then((response) => response.json())
      .then(({ data, errors }: Response) => {
        if (errors) {
          console.error(errors);
          return;
        }

        setData(data);
      });
  }, []);

  if (!data || data.prijzenkastUitlegCollection.items.length <= 0) return null;

  const { titel, tekst } = data.prijzenkastUitlegCollection.items[0];

  return <HelpPopup title={titel} description={tekst} />;
};

export default HelpPopupContainer;
